import React from 'react';
import { Paper, Typography } from '@mui/material';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import PeopleIcon from '@mui/icons-material/People';
import { useTranslation } from 'react-i18next';
import StatCard from '../StatCard';
import StatCardsRow from '../StatCardsRow';
import EarningsBarChartMonthly from '../Charts/EarningsBarChartMonthly';
import { statPaper, statTitle } from '../../../styles/CalculateMoney/OverviewCommonStyles';

function getMonthlyArr(data) {
  if (!data) return [];
  if (Array.isArray(data)) return data;
  if (Array.isArray(data.$values)) return data.$values;
  return [];
}

export default function OverviewMonthView({ data, year, onYearChange }) {
  const { t } = useTranslation('overview');
  const monthlyArr = getMonthlyArr(data);

  const totalEarnings = monthlyArr.reduce((sum, m) => sum + (m.totalEarnings || 0), 0);
  const totalSessions = monthlyArr.reduce((sum, m) => sum + (m.sessionCount || 0), 0);

  return (
    <>
      <StatCardsRow>
        <StatCard
          icon={<MonetizationOnIcon fontSize="large" />}
          label={t('stats.totalEarnings')}
          value={`${totalEarnings} €`}
          color="primary"
        />
        <StatCard
          icon={<PeopleIcon fontSize="large" />}
          label={t('stats.totalSessions')}
          value={totalSessions}
          color="success"
        />
      </StatCardsRow>
      <Paper elevation={0} sx={statPaper}>
        <Typography variant="subtitle1" sx={statTitle}>
          {t('month.overviewForYear', { year })}
        </Typography>
        <EarningsBarChartMonthly monthlyDetails={data} year={year} />
      </Paper>
    </>
  );
}